/* Legeldle kiegészítő termék ajánló blokk
   - változatválasztó árfrissítés
   - pipa esetén az ajánlott termék(ek) kosárba tétele a fő termékkel együtt
   - több kártya (2. ajánlott termék) együttes kezelése
   - quick view modalban is működik: ha nincs meg az űrlap azonosító alapján,
     a modalon belül keresi meg
   - a téma kosárfiókjának újratöltése a kosárba tétel után
*/

if (!customElements.get('legeldle-ajanlo')) {

  class LegeldleAjanlo extends HTMLElement {

    connectedCallback() {

      this.check = this.querySelector('[data-la-check]');
      this.variantInput = this.querySelector('[data-la-variant]');
      this.saleEl = this.querySelector('[data-la-sale]');
      this.origEl = this.querySelector('[data-la-orig]');
      this.card = this.querySelector('.legeldle-ajanlo__card');

      if (!this.check || !this.variantInput) return;

      // Árfrissítés változatváltáskor (előre kiszámolt, formázott árakból)
      if (this.variantInput.tagName === 'SELECT') {
        this.variantInput.addEventListener('change', () => {
          const opt = this.variantInput.selectedOptions[0];
          if (!opt) return;
          if (this.saleEl && opt.dataset.sale) this.saleEl.textContent = opt.dataset.sale;
          if (this.origEl && opt.dataset.orig) this.origEl.textContent = opt.dataset.orig;
        });
      }

      // A kártyára kattintva is pipálható (kivéve a legördülőt)
      if (this.card) {
        this.card.addEventListener('click', (e) => {
          if (e.target.closest('select, option, input, a')) return;
          this.check.checked = !this.check.checked;
        });
      }

      // Kapcsolódás a termék űrlapjához
      let productForm = null;
      if (this.dataset.sectionId) {
        productForm = document.getElementById('add-to-cart-' + this.dataset.sectionId);
      }
      if (!productForm) {
        // Quick view modal (vagy bármely környezet, ahol nincs section id):
        // a legközelebbi termékoldal-konténeren belül keressük az űrlapot
        const scope = this.closest('[data-js-product-page]') || document;
        productForm = scope.querySelector('product-form[id^="add-to-cart-"]');
      }
      if (!productForm) return;

      this._form = productForm;

      if (productForm.hasAttribute('data-ajax-cart')) {
        // Fiókos/felugrós kosár: a téma sikeres kosárba tétele után tesszük mellé az ajánlott terméket
        productForm.addEventListener('add-to-cart', () => {
          if (this.check.checked) this._addCompanion();
        });
      } else {
        // Kosároldalas mód: egyben adjuk fel az összes bepipált ajánlott terméket a fő termékkel,
        // majd irány a kosároldal. Több kártya esetén csak az első kezelő intézkedik
        // (a többi a defaultPrevented alapján kimarad).
        const form = productForm.querySelector('form');
        if (form) {
          form.addEventListener('submit', (e) => {
            if (e.defaultPrevented) return;
            const cards = Array.from(document.querySelectorAll('legeldle-ajanlo')).filter(
              (el) => el._form === productForm && el.check && el.check.checked
            );
            if (!cards.length) return;
            e.preventDefault();
            e.stopPropagation();
            const idInput = form.querySelector('input[name="id"]');
            const qtyInput = form.querySelector('input[name="quantity"]');
            const qty = qtyInput ? (parseInt(qtyInput.value, 10) || 1) : 1;
            const items = [{ id: parseInt(idInput.value, 10), quantity: qty }];
            cards.forEach((c) => {
              items.push({ id: parseInt(c.variantInput.value, 10), quantity: 1 });
            });
            fetch(KROWN.settings.routes.cart_add_url + '.js', {
              method: 'POST',
              headers: {
                'Content-Type': 'application/json',
                'X-Requested-With': 'XMLHttpRequest'
              },
              body: JSON.stringify({ items: items })
            }).finally(() => {
              document.location.href = KROWN.settings.routes.cart_url;
            });
          }, true);
        }
      }

    }

    _addCompanion() {
      fetch(KROWN.settings.routes.cart_add_url + '.js', {
        method: 'POST',
        headers: {
          'Content-Type': 'application/x-www-form-urlencoded',
          'X-Requested-With': 'XMLHttpRequest'
        },
        body: 'id=' + encodeURIComponent(this.variantInput.value) + '&quantity=1'
      })
        .then((r) => r.json())
        .then((res) => {
          if (res && res.status == 422) return;
          this._refreshCartDrawer();
        })
        .catch(() => {});
    }

    _refreshCartDrawer() {
      fetch('?section_id=helper-cart')
        .then((r) => r.text())
        .then((text) => {
          const html = new DOMParser().parseFromString(text, 'text/html');

          const srcForm = html.getElementById('AjaxCartForm');
          const dstForm = document.getElementById('AjaxCartForm');
          if (srcForm && dstForm) {
            dstForm.innerHTML = srcForm.innerHTML;
            if (typeof dstForm.ajaxifyCartItems === 'function') {
              dstForm.ajaxifyCartItems();
            }
          }

          const srcSub = html.getElementById('AjaxCartSubtotal');
          const dstSub = document.getElementById('AjaxCartSubtotal');
          if (srcSub && dstSub) dstSub.innerHTML = srcSub.innerHTML;

          const count = html.querySelector('[data-cart-count]');
          if (count) {
            document.querySelectorAll('[data-header-cart-count]').forEach((el) => {
              el.textContent = count.textContent;
            });
          }
          const total = html.querySelector('[data-cart-total]');
          if (total) {
            document.querySelectorAll('[data-header-cart-total]').forEach((el) => {
              el.textContent = total.textContent;
            });
          }
        })
        .catch(() => {});
    }

  }

  customElements.define('legeldle-ajanlo', LegeldleAjanlo);

}
